import React from 'react'
import s from './GeoentityBlocks.less'
import { useSelector } from 'react-redux'
import { selectSelectedGeoentityBlocks } from '../../../store/geoentity/geoentity.selectors'
import GeoentityBlock from './GeoentityBlock'
import GeoentityBlocksSelector from './GeoentitytBlocksSelector'
import { selectIsGeoentityOnItineraryPage } from '../../../store/history/history.selectors'
import classNames from 'classnames'

const GeoentityBlocks = () => {
  const blocks = useSelector(selectSelectedGeoentityBlocks)
  const isSmrRoute = useSelector(selectIsGeoentityOnItineraryPage)

  if (!blocks || blocks.length === 0) return <></>

  return (
    <div className={s.wrapper}>
      <GeoentityBlocksSelector />
      <div className={classNames(isSmrRoute && s.blocksWrapper)}>
        {blocks.map((block, idx) => (
          <GeoentityBlock key={idx} block={block} />
        ))}
      </div>
    </div>
  )
}

export default GeoentityBlocks
